import createCustomPropType from '../createCustomPropType';

// Valid Href custom prop type
// This custom prop validator ensures that links are used correctly and are provided
// an acceptable href attribute.

// Throws an error when `#` or an empty string is passed to a prop that expects a valid URL,
// such as a link href attribute.
const isValidHref = (props, propName, componentName) => {
  if (/^#$/.test(props[propName])) {
    throw new Error(
      `'#' is not a valid value for \`${propName}\` - supplied to \`${componentName}\`. Please use a valid URL or use a Button.`
    );
  } else if (
    typeof props[propName] === 'string' &&
    props[propName].length === 0
  ) {
    throw new Error(
      `An empty string is not a valid value for \`${propName}\` - supplied to \`${componentName}\`. Please use a valid URL or use a Button.`
    );
  }
};

const validHref = createCustomPropType(isValidHref);

export default validHref;
